import { normalizeModuleDefault } from '@eventbrite/legacy-infra.transformation-utils';
export { Theme } from './_internal/Theme';
export { THEME_PROP_TYPE } from './_internal/constants';
export { genTheme } from './_internal/utils';

import * as _day from './themes/day/colors.json';
import * as _night from './themes/night/colors.json';

const day = normalizeModuleDefault(_day);
const night = normalizeModuleDefault(_night);

export { day, night };
